import { Link } from 'react-router-dom';
import CardBig from '../Big';
var CardSituation = function (_a) {
    var title = _a.title, description = _a.description, icon = _a.icon, to = _a.to, from = _a.from;
    return (<Link to={to} state={{ from: from }}>
      <CardBig title={title} description={description} icon={icon}/>
    </Link>);
};
export default CardSituation;
